import React, { useEffect } from "react";
import "../styles/StatusModal.css";

const StatusModal = ({
  open,
  type = "success", // "success" | "error"
  message = "",
  onClose,
  autoClose = true,
  duration = 2000
}) => {

  // ✅ Auto close logic
  useEffect(() => {
    if (open && autoClose) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [open, autoClose, duration, onClose]);

  if (!open) return null;

  return (
    <div className="status-modal-overlay" onClick={onClose}>
      <div
        className={`status-modal-container ${type}`}
        onClick={(e) => e.stopPropagation()}
      >

        {/* ✅ HEADER */}
        <div className="status-modal-header">
          <span className="status-modal-title">
            {type === "success" ? "Success" : "Error"}
          </span>
        </div>

        {/* ✅ MAIN CONTENT */}
        <div className="status-modal-main">
          <div className="status-modal-icon">
            {type === "success" ? "✅" : "❌"}
          </div>
          <div className="status-modal-message">{message}</div>
        </div>

        {/* ✅ FOOTER */}
        {!autoClose && (
          <div className="status-modal-footer">
            <button className="status-modal-btn" onClick={onClose}>
              Close
            </button>
          </div>
        )}

      </div>
    </div>
  );
};

export default StatusModal;
